import { SectionHeader } from "./section-header"

const steps = [
  {
    icon: "🎯",
    title: "Monte seu treino",
    desc: "Escolha os estímulos e defina a resposta para cada um: tocar um cone, mudar de direção, pular, responder uma pergunta.",
  },
  {
    icon: "📲",
    title: "Conecte uma tela",
    desc: "Escaneie o QR code e transforme qualquer celular, tablet ou TV em um painel de estímulos. Quem treina não precisa de conta.",
  },
  /*{
    icon: "📈",
    title: "Meça e evolua",
    desc: "Clique para revelar a cor, meça o tempo de reação e marque acerto ou erro. Os dados são registrados automaticamente. Acompanhe a evolução session após session.",
  },*/
  {
    icon: "🏆",
    title: "Treine e acompanhe",
    desc: "Revele os estímulos, marque acertos e erros e veja cada tempo de reação virar histórico de evolução.",
  }
]

export function HowItWorks() {
  return (
    <section id="como-funciona" className="py-24 md:py-32 relative">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeader
          eyebrow="Como funciona"
          title={<>Em 3 passos simples, seu treino ganha <span className="text-primary">estímulos, desafio e dados</span>.</>}
        />

        <div className="mt-16 grid md:grid-cols-3 gap-6 relative">
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px border-t border-dashed border-primary/30" />

          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative rounded-2xl bg-card border border-white/5 hover:border-primary/30 p-7 transition-all hover:-translate-y-1 hover:glow-primary-sm group"
            >
              <div className="flex items-center justify-between mb-5">
                <div className="h-14 w-14 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center text-3xl">
                  {s.icon}
                </div>
                <span className="text-5xl font-extrabold text-primary/15 group-hover:text-primary/30 transition-colors">
                  0{i + 1}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-2">{s.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
